import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './farmerdetails.css'; // Reusing same styles

const EmployeeDetails = () => {
  const { state } = useLocation();

  const [showPassword, setShowPassword] = useState(false);

  const [details, setDetails] = useState({
    empid: state?.empid || '',
    empname: state?.empname || '',
    ph: state?.ph || '',
    password: '',
    role: 'employee',
    dob: '',
    aadhar: '',
    area: '',
    village: '',
    bankName: '',
    accountNumber: '',
    ifsc: ''
  });

  useEffect(() => {
    if (state?.empid) {
      fetch(`https://kmtea.onrender.com/getemployeedata/${state.empid}`)
        .then(res => {
          if (!res.ok) throw new Error('No existing data');
          return res.json();
        })
        .then(data => setDetails(data))
        .catch(err => console.log('New Employee Entry'));
    }
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!details.empid || !details.empname || !details.ph || !details.password) {
      alert('Emp ID, Name, Phone, and Password are required');
      return;
    }

    try {
      const res = await fetch('https://kmtea.onrender.com/saveemployeedata', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(details),
      });
      const msg = await res.text();
      alert(msg);
    } catch (err) {
      alert('Error saving employee data');
    }
  };

  return (
    <div className="farmer-details">
      <h2>Employee Registration</h2>

      {/* Section 1: Personal Info */}
      <div className="farmer1">
        <h3>Personal Info</h3>
        <div className="farm">
          <div>
            <label>Emp ID</label>
            <input
              name="empid"
              value={details.empid}
              onChange={handleChange}
              readOnly={state?.empid ? true : false}
              placeholder="Employee ID"
            />
          </div>
          <div>
            <label>Name</label>
            <input
              name="empname"
              value={details.empname}
              onChange={handleChange}
              placeholder="Employee Name"
            />
          </div>
          <div>
            <label>Phone</label>
            <input
              name="ph"
              value={details.ph}
              onChange={handleChange}
              placeholder="Phone Number"
            />
          </div>
        </div>

        <div className="dob">
          <div style={{ position: 'relative' }}>
            <label>Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={details.password}
              onChange={handleChange}
              placeholder="Password"
            />
            <span
              onClick={() => setShowPassword(prev => !prev)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer'
              }}
            >
              {showPassword ? '🙈' : '👁️'}
            </span>
          </div>
          <div>
            <label>Role</label>
            <select name="role" value={details.role} onChange={handleChange}>
              <option value="employee">Employee</option>
              <option value="admin">Admin</option>
            </select>
          </div>
        </div>

        <div className="dob">
          <div>
            <label>DOB</label>
            <input
              type="date"
              name="dob"
              value={details.dob}
              onChange={handleChange}
            />
          </div>
          <div>
            <label>Aadhar No</label>
            <input
              name="aadhar"
              value={details.aadhar}
              onChange={handleChange}
              placeholder="Aadhar Number"
            />
          </div>
        </div>
      </div>

      {/* Section 2: Address */}
      <div className="farmer2">
        <h3>Address</h3>
        <div className="city">
          <div>
            <label>City / Area</label>
            <input
              name="area"
              value={details.area}
              onChange={handleChange}
              placeholder="City / Area"
            />
          </div>
          <div>
            <label>Village / Pincode</label>
            <input
              name="village"
              value={details.village}
              onChange={handleChange}
              placeholder="Village / Pincode"
            />
          </div>
        </div>
      </div>

      {/* Section 3: Bank Info */}
      <div className="farmer3">
        <h3>Bank Info</h3>
        <div>
          <label>Bank Name</label>
          <input
            name="bankName"
            value={details.bankName}
            onChange={handleChange}
            placeholder="Bank Name"
          />
        </div>
        <div>
          <label>Account Number</label>
          <input
            name="accountNumber"
            value={details.accountNumber}
            onChange={handleChange}
            placeholder="Account Number"
          />
        </div>
        <div>
          <label>IFSC Code</label>
          <input
            name="ifsc"
            value={details.ifsc}
            onChange={handleChange}
            placeholder="IFSC Code"
          />
        </div>
      </div>

      {/* Submit */}
      <center>
        <button onClick={handleSave}>Save Employee</button>
      </center>
    </div>
  );
};

export default EmployeeDetails;
